module.exports = __webpack_public_path__ + "img/20180815_154807_246.56c4b80d.jpg";